<template>
<span id="progress-area">
  <Transition name="fade">
    <vue-ellipse-progress
      v-show="showProgressBar"
      class="progress-circle-bar"
      :progress="firstEndedExam ? progress : 100"
      :color="color"
      thickness="6"
      emptyThickness="3"
      lineMode="normal"
      :legendFormatter="firstEndedExam ? percentFormatter : textLegendFormatter"
      :fontSize="firstEndedExam ? fontSize : legendFontSize"
      legendClass="circle-legend"
      :emptyColorFill="emptyColorFill"
      :size="size"
    />
  </Transition>

  <Transition name="bounce">
        <img v-if="showStamp" :src="stamp" class="d-inline-block align-left stamp" :style="'height: '+size+'px'" alt="badge"/>
  </Transition>
  <confetti></confetti>
</span>
</template>

<script>
import Store from '@/store/index.js'
import confetti from 'canvas-confetti'

export default {
    components: {
        confetti
    },
  props: {
    progress: Number,
    exams: Array,
    plus: Boolean,
    order: Number
  },
  methods: {
     percentFormatter : ({ currentValue }) => {
     return `
        ${new Intl.NumberFormat("fr-FR").format(currentValue)}
        <span>%</span>
      `;
    },
     blankFormatter : () => {
     return `Testez vos connaissances`;
    },
     notAvailable : () => {
     return `Accessible avec Digital Citizen +`;
    },
    textLegendFormatter() {
      if (this.plus==true && !this.isPlusUser) {
        return "Accessible avec Digital Citizen +"
      }
      else if (this.plus==true && this.isPlusUser && this.nbModulesCompleted<5) {
        this.legendFontSize= "1rem"
        return `Complétez Digital Citizen pour débloquer ce module`
      }
      else {
        return "Testez vos connaissances"
      }
    },
    launchConfetti() {
      let coordinates= [
        {x:0.2, y:0.6, angle:60},
        {x:0.8, y:0.6, angle:120},
        {x:0.5, y:0.4, angle:90},
      ]
      coordinates.forEach((coordinate) => {
            confetti({
              particleCount: 40,
              angle: coordinate.angle,
              spread: 100,
              origin: { 
                x: coordinate.x,
                y: coordinate.y
              },
              scalar: 1.75,
              ticks: 500,
              colors: [
                "#003C71",
                "#78BE20", 
                "#CB2C30",
                "#D1D3D4",
                "#009FDF",
                "#F2A900",
                "#AF1685",
              ]
            });
      })
    }
  },
  data () {
    return {
      legendFontSize: "1.3rem",
      showProgressBar: true,
      showStamp: false
    }
  },
  computed : {
    stamp() {
      let images = require.context('../assets/stamps/', false, /\.png$/)
      let stampName = "MODULE-"
      if(this.plus==true) {stampName+= "PLUS-"}
      stampName+= this.order;
      return images('./' + stampName + ".png")
    },
    isPlusUser() {return Store.getters.getIsPlus()},
    firstEndedExam: function () {
      return (this.exams.length>0 && this.exams[this.exams.length-1].is_ended == true) ? true : false
    },
    size () {
      return (this.$route.name == "Result") ? 250 : 200
    },
    fontSize () {
      return (this.$route.name == "Result") ? "2.5rem" : "2rem"
    },
    emptyColorFill: function () {
        return {
          radial: true,
          colors: [
            {
              color: this.color,
              offset: "100",
              opacity: "0.25",
            },
          ],
        }
    },
    nbModulesCompleted() {return parseInt(Store.getters.getNbModulesCompleted())},
    color: function () {
      if ((this.plus==true && !this.isPlusUser) || (this.plus==true && this.isPlusUser && this.nbModulesCompleted<5)) {
        return "#808285"
      }
      if (!this.firstEndedExam) {
        return "#009FDF"
      }
      if (this.progress < 20) {
        return "#CB2C30"
      }
      else if (this.progress < 40) {
        return "#E04E39"
      }
      else if (this.progress < 60) {
        return "#E57200"
      }
      else if (this.progress < 80) {
        return "#F2A900"
      }
      else if (this.progress < 100) {
        return "#C4D600"
      }
      else if (this.progress >= 100) {
        return "#78BE20"
      }
      else {
        return "#CB2C30"
      }
    },
  },
  mounted() {
    if(this.progress>=100) {
      setTimeout(() => {
        this.showProgressBar = false
        setTimeout(() => {
          this.showStamp = true;
          if(this.$route.name=="Result") {
            this.launchConfetti()
          }
        }, 600)
      }, 1600);
    }
  },
  beforeDestroy() {
    // Fait disparaitre les confettis, en cas de changement de page si l'animation n'est pas terminée
    confetti.reset()
  }
}
</script>
<style scoped>
  #progress-area {
    position: relative;
    height: 100%
  }
  .stamp {
    height: 250px;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }.bounce-enter-active {
  animation: bounce-in 0.4s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}
</style>